import React from 'react';

class ValidationMessage extends React.Component {
    render() {
        return (
            <div style={{backgroundColor: '#cccccc', marginTop:5, padding: 2, borderRadius:7  }} >
               <p style={{color:'#d50000', margin:5 }} >{this.props.message}</p>
            </div>
        )
    }
}
export default ValidationMessage;


// WEBPACK FOOTER //
// ./src/Components/ValidationMessage.js